import { motion } from "framer-motion";
import { BIO, BIO_2, CREDENTIALS, SKILLS, IMAGES } from "@/data/site";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.5, delay: i * 0.08 } }),
};

export default function About({ embedded = false }) {
  return (
    <div data-testid="about-page" className={embedded ? "" : "pt-16"}>
      {/* Header */}
      <section className="relative bg-ink text-cream py-28 md:py-40 overflow-hidden">
        <img
          src="https://customer-assets.emergentagent.com/job_nancy-drums/artifacts/f9ozbv4t_Nancy%20and%20Ben__42.webp"
          alt="Nancy Naden playing drums from above"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-ink/70" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-8">
          <h1 className="font-display text-5xl md:text-7xl font-black tracking-tighter leading-none">
            About
          </h1>
        </div>
      </section>

      {/* Bio + portrait */}
      <section className="bg-cream py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-7">
            <p className="font-display text-2xl md:text-3xl leading-snug tracking-tight text-ink">
              {BIO}
            </p>
            <p className="mt-8 text-steel text-base md:text-lg leading-relaxed">{BIO_2}</p>

            <div className="mt-12 flex flex-wrap gap-3" data-testid="skills-list">
              {SKILLS.map((s) => (
                <span
                  key={s}
                  className="rounded-full bg-terracotta text-ink font-medium px-4 py-2 text-sm"
                >
                  {s}
                </span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="overflow-hidden rounded-3xl border border-teal/30">
              <img
                src={IMAGES.portrait}
                alt="Nancy Naden portrait"
                className="w-full h-[520px] object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Credentials bento */}
      <section className="relative py-20 md:py-28 overflow-hidden">
        <img
          src="/spd-sx.webp"
          alt="Roland SPD-SX PRO sampling pad"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-ink/80" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-8">
          <h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight text-cream mb-12">
            Credentials & tools
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-start" data-testid="credentials-grid">
            {CREDENTIALS.map((c, i) => (
              <motion.div
                key={c.title}
                custom={i}
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.3 }}
                className="rounded-3xl bg-cream border border-teal/30 p-8 md:p-10"
                data-testid={`credential-${i}`}
              >
                <h3 className="font-display text-2xl md:text-3xl text-ink mb-3">{c.title}</h3>
                {c.tools ? (
                  <ul className="mt-4 divide-y divide-teal/20">
                    {c.tools.map((t) => (
                      <li key={t.name} className="py-3 first:pt-0 last:pb-0">
                        <p className="font-semibold text-ink">{t.name}</p>
                        <p className="text-sm text-terracotta leading-relaxed">{t.detail}</p>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-steel leading-relaxed">{c.detail}</p>
                )}
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
